import { Box } from '@migros/msrc-ui-kit';
import React from 'react';
import { ArticleMini } from '../../components/article-mini/ArticleMini';
import { Article } from '../../components/article/Article';
import { ArticleMiniSkeleton } from '../../components/skeleton/ArticleMiniSkeleton';
import { ArticleSkeleton } from '../../components/skeleton/ArticleSkeleton';
import { ArrowNext, ArrowPrev } from '../../components/slider/Arrows';
import { Slider } from '../../components/slider/Slider';
import { ListStyleType, TileLayout, defaultOptions, parseResponsiveStylesArray } from '../../helpers';
export const ArticleSlider = ({
  articles,
  language,
  heading,
  hideDescription,
  hideRating,
  hideEnergyEfficiency,
  hideBadge,
  linkToFm,
  loading = false,
  mode,
  skeletonCount,
  layout,
  tilesVisibleCount,
  onSwipe,
  onPrevArrowClick,
  onNextArrowClick,
  onArticleClick,
  onArticleImpression,
  customTarget = {}
}) => {
  const breakpoints = [767, 991, 1200];
  const parsedTilesVisible = parseResponsiveStylesArray(tilesVisibleCount, defaultOptions.tilesVisibleCount[layout]).map(count => Math.min(count, articles.length));
  const parsedTileLastIndex = parsedTilesVisible.length - 1;
  const parsedTilesVisibleArray = parsedTilesVisible.slice(1, parsedTileLastIndex).map((value, index) => ({
    breakpoint: breakpoints[index],
    settings: {
      slidesToShow: value,
      slidesToScroll: Math.floor(value)
    }
  }));
  const settings = {
    onSwipe: swipeDirection => {
      if (onSwipe) {
        onSwipe(swipeDirection);
      }
    },
    infinite: false,
    dots: false,
    speed: 300,
    slidesToShow: parsedTilesVisible[parsedTileLastIndex],
    slidesToScroll: Math.floor(parsedTilesVisible[parsedTileLastIndex]),
    arrows: true,
    prevArrow: /*#__PURE__*/React.createElement(ArrowPrev, {
      customOnClick: onPrevArrowClick,
      language: language
    }),
    nextArrow: /*#__PURE__*/React.createElement(ArrowNext, {
      customOnClick: onNextArrowClick,
      language: language
    }),
    responsive: [...parsedTilesVisibleArray, {
      // mobile viewport settings are handled via css in the <Slider> component
      breakpoint: 479,
      settings: 'unslick'
    }]
  };
  const gutterName = 'small';
  return /*#__PURE__*/React.createElement(Slider, {
    sliderSettings: settings,
    mode: mode,
    layout: layout,
    tilesVisibleMobile: parsedTilesVisible[0]
  }, articles.length <= 0 && loading ? Array.from(Array(skeletonCount), (_, count) => {
    // This case should only happen on initial data load
    return /*#__PURE__*/React.createElement(Box, {
      key: count,
      paddingLeft: [mode === ListStyleType.fancy ? gutterName : null],
      paddingTop: [mode === ListStyleType.fancy ? gutterName : null]
    }, layout === TileLayout.mini ? /*#__PURE__*/React.createElement(ArticleMiniSkeleton, {
      mode: mode
    }) : /*#__PURE__*/React.createElement(ArticleSkeleton, {
      mode: mode
    }));
  }) : articles.map((article, index) => {
    return /*#__PURE__*/React.createElement(Box, {
      key: `${article.id}-${index}`,
      paddingLeft: [mode === ListStyleType.fancy ? gutterName : null],
      paddingTop: [mode === ListStyleType.fancy ? gutterName : null]
    }, layout === TileLayout.default && /*#__PURE__*/React.createElement(Article, {
      article: article,
      hideDescription: hideDescription,
      hideRating: hideRating,
      hideEnergyEfficiency: hideEnergyEfficiency,
      hideBadge: hideBadge,
      linkToFm: linkToFm,
      mode: mode,
      heading: heading,
      language: language,
      loading: loading,
      onClick: () => {
        if (onArticleClick) {
          onArticleClick(article, index);
        }
      },
      onImpression: () => {
        if (onArticleImpression) {
          onArticleImpression(article, index);
        }
      },
      customTarget: customTarget
    }), layout === TileLayout.mini && /*#__PURE__*/React.createElement(ArticleMini, {
      article: article,
      hideEnergyEfficiency: hideEnergyEfficiency,
      hideDescription: hideDescription,
      hideBadge: hideBadge,
      loading: loading,
      mode: mode,
      heading: heading,
      language: language,
      onClick: () => {
        if (onArticleClick) {
          onArticleClick(article, index);
        }
      },
      onImpression: () => {
        if (onArticleImpression) {
          onArticleImpression(article, index);
        }
      },
      customTarget: customTarget
    }));
  }));
};